import { Button, Input, Form, FormGroup, Row, Col } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'

export default function CaseSearchForm({ location, objectId, fieldId, caseSearchCallback }) {
  console.log('CaseSearchForm rendered', location)

  let initialInputs = {
    objectId: objectId,
    fieldId: fieldId,
    plaintiffLastName: '',
    plaintiffFirstName: '',
    plaintiffSSN: '',
    plaintiffDOB: '',
    recordId: ''
  }
  if (location) {
    // previous inputs
    const params = new URLSearchParams(location.search)
    initialInputs = JSON.parse(params.get('inputs'))
  }

  const { inputs, handleInputChange, handleSubmit } = useForm(initialInputs, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('PlaintiffSearchForm.submitSearch', inputs)
    const url = `bossci.case_selection?inputs=${JSON.stringify(inputs)}`
    caseSearchCallback(url)
  }
  return (
    <div style={{ textAlign: 'center'}}>
      <div style={{ display: 'inline-block', margin: '10px auto' }}>
        <Form inline className="plaintiff-search-form" onSubmit={handleSubmit}>
          <Row>
            <Col>
              <FormGroup>
                <Input name='plaintiffLastName' placeholder='Last Name' style={{ minWidth: '100px' }} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Input name='plaintiffFirstName' placeholder='First Name' style={{ minWidth: '100px' }} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Input name='plaintffSSN' placeholder='SSN' style={{ minWidth: '100px' }} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Input name='plaintiffDOB' placeholder='DOB' style={{ minWidth: '100px' }} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Input name='recordId' placeholder='Record ID' style={{ minWidth: '100px' }} onChange={handleInputChange} />
              </FormGroup>
            </Col>
          </Row>
          <Button className='plaintiff-search-button' color="primary">Search</Button>
        </Form>
      </div>
    </div>
  )
}